import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { type RootState } from 'store';

export const getBaseQuery = (url: string) =>
    fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}${url}`,
        prepareHeaders: (headers, { getState }) => {
            headers.set('authorization', `Bearer ${(getState() as RootState).auth.accessToken}`);
            return headers;
        },
    });
